/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { getUser, getUsers, editUser } from '../../utils/http';
import { setLocalStorage } from '../../utils/localeStorage/storage';
import api from '../../utils/directualAPI/api';
import logo from '../../assets/icons/logoWhite.svg';
import './LoginPage.less';


function LoginPage({ history, location }) {
  const [loading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [isShowLoginModal, setIsShowLoginModal] = useState(false);
  const [isShowRegModal, setIsShowRegModal] = useState(false);
  const [errorFields, setErrorFields] = useState([]);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  useEffect(() => {
    getUsers().then((resp) => {
      setIsLoading(false);
      setUsers(resp);
    });
  }, []);

  useEffect(() => {
    if (isShowLoginModal || isShowRegModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isShowLoginModal, isShowRegModal]);

  const onLogin = () => {
    setErrorFields([]);
    const login = document.getElementById('login-login')?.value || null;
    const pass = document.getElementById('login-pass')?.value || null;
    const errors = [];
    if (!login) {
      errors.push('login');
    }
    if (!pass) {
      errors.push('pass');
    }
    if (errors.length > 0) {
      setErrorFields(errors);
      return;
    }

    const username = [
      ...users,
      { id: login, shortName: login, email: login },
    ].find((u) => u.shortName === login || u.email === login).id;
    api
      .structure()
      .auth(username, pass)
      .then((response) => {
        if (response.isError) {
          setErrorFields(['login', 'pass']);
          setIsLoading(false);
        } else {
          getUser(username, response.token).then((user) => {
            const payload = {
              token: response.token,
              ...user,
              birthdayDate: user.birthdayDate
                ? user.birthdayDate.toISOString()
                : '',
            };
            setLocalStorage(payload);
            setIsLoading(false);
            const from = get(location, 'state.from.pathname', '/homePage');
            history.push(from);
          });
        }
      });
  };

  const onRegister = () => {
    setErrorFields([]);
    const fields = [
      'lastName',
      'position',
      'firstName',
      'phone',
      'middleName',
      'email',
      'fullName',
    ];
    const values = {};
    const errors = [];
    fields.forEach((field) => {
      const fieldName = `reg-${field}`;
      values[field] = document.getElementById(fieldName)?.value || null;
      if (!values[field]) {
        errors.push(field);
      }
    });

    const isDzm = document.getElementById('reg-isDzm')?.checked || null;
    values.isDzm = isDzm;

    if (errors.length > 0) {
      setErrorFields(errors);
      return;
    }

    if (errorFields.length === 0) {
      setIsLoading(true);
      editUser(values).then(() => {
        setIsLoading(false);
        setIsShowRegModal(false);
        setIsShowSuccess(true);
      });
    }
  };

  return (
    <div className="welcome-page">
      <div className="welcome-page__wrapper">
        <div className="welcome-page__header">

          <div>
            <div className="welcome-page__title">грантовая программа МЭРА МОСКВЫ</div>

            <a href="/Приказ_Департамента_здравоохранения_города_Москвы_№_991.pdf" target="_blank" className="welcome-page__file">
              <div className="welcome-page__file-icon">
                <svg width="30" height="38" viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.1205 2.03395L18.1225 2.03592L27.9667 11.9771C27.967 11.9774 27.9672 11.9776 27.9674 11.9778C28.6492 12.6725 29.0146 13.2209 29.2229 13.84C29.4361 14.4736 29.5 15.2238 29.5 16.3593V32.4524C29.5 34.219 29.0601 35.4568 28.2654 36.2561C27.4712 37.0549 26.2387 37.5 24.4706 37.5H5.5294C3.76988 37.5 2.53706 37.0589 1.74063 36.2618C0.944111 35.4646 0.5 34.2271 0.5 32.4524V5.56577C0.5 3.79998 0.943859 2.55673 1.74189 1.75227C2.5392 0.948536 3.77226 0.5 5.5294 0.5H14.0016C14.9902 0.5 15.7028 0.575055 16.3199 0.794482C16.9274 1.01051 17.4806 1.38051 18.1205 2.03395ZM14.1089 2.85321V2.35321H13.6089H5.68997C4.67418 2.35321 3.82539 2.6313 3.23157 3.22423C2.6378 3.81713 2.37124 4.65266 2.37124 5.61871V32.3994C2.37124 33.3731 2.63727 34.2058 3.23097 34.793C3.82385 35.3794 4.66847 35.6468 5.67171 35.6468H24.3283C25.3391 35.6468 26.1849 35.38 26.7764 34.7922C27.3684 34.2039 27.6288 33.3707 27.6288 32.3994V16.4833V15.9833H27.1288H16.9618C15.9324 15.9833 15.2423 15.7278 14.8071 15.2987C14.3732 14.8709 14.1089 14.1881 14.1089 13.1514V2.85321ZM16.1768 13.9288C16.4742 14.2279 16.8839 14.3063 17.283 14.3063C17.283 14.3063 17.283 14.3063 17.283 14.3063L26.5747 14.307L27.7713 14.3071L26.9305 13.4557L16.6571 3.05167L15.8013 2.18501V3.40299V12.8141C15.8013 13.2191 15.8801 13.6304 16.1768 13.9288Z" fill="white" stroke="white" />
                  <path d="M14.6464 31.3536C14.8417 31.5488 15.1583 31.5488 15.3536 31.3536L18.5355 28.1716C18.7308 27.9763 18.7308 27.6597 18.5355 27.4645C18.3403 27.2692 18.0237 27.2692 17.8284 27.4645L15 30.2929L12.1716 27.4645C11.9763 27.2692 11.6597 27.2692 11.4645 27.4645C11.2692 27.6597 11.2692 27.9763 11.4645 28.1716L14.6464 31.3536ZM14.5 19L14.5 31L15.5 31L15.5 19L14.5 19Z" fill="white" />
                </svg>
              </div>
              <div className="welcome-page__file-info">
                <div className="welcome-page__file-title">Приказ</div>
                <div className="welcome-page__file-subtitle">Департамента здравоохранения города Москвы № 991 от 07.11.2024</div>
              </div>
            </a>
          </div>

          <div>
            <div className="welcome-page__subtitle">
              итоги заявочной кампании
              <span>конкурсного отбора научно- практических проектов</span>
              <span className="welcome-page__year">2024 год</span>
            </div>

            <a href="/Перечень_поддержанных_проектов_по_итогам_конкурсного_отбора_2024.pdf" target="_blank" className="welcome-page__file">
              <div className="welcome-page__file-icon">
                <svg width="30" height="38" viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.1205 2.03395L18.1225 2.03592L27.9667 11.9771C27.967 11.9774 27.9672 11.9776 27.9674 11.9778C28.6492 12.6725 29.0146 13.2209 29.2229 13.84C29.4361 14.4736 29.5 15.2238 29.5 16.3593V32.4524C29.5 34.219 29.0601 35.4568 28.2654 36.2561C27.4712 37.0549 26.2387 37.5 24.4706 37.5H5.5294C3.76988 37.5 2.53706 37.0589 1.74063 36.2618C0.944111 35.4646 0.5 34.2271 0.5 32.4524V5.56577C0.5 3.79998 0.943859 2.55673 1.74189 1.75227C2.5392 0.948536 3.77226 0.5 5.5294 0.5H14.0016C14.9902 0.5 15.7028 0.575055 16.3199 0.794482C16.9274 1.01051 17.4806 1.38051 18.1205 2.03395ZM14.1089 2.85321V2.35321H13.6089H5.68997C4.67418 2.35321 3.82539 2.6313 3.23157 3.22423C2.6378 3.81713 2.37124 4.65266 2.37124 5.61871V32.3994C2.37124 33.3731 2.63727 34.2058 3.23097 34.793C3.82385 35.3794 4.66847 35.6468 5.67171 35.6468H24.3283C25.3391 35.6468 26.1849 35.38 26.7764 34.7922C27.3684 34.2039 27.6288 33.3707 27.6288 32.3994V16.4833V15.9833H27.1288H16.9618C15.9324 15.9833 15.2423 15.7278 14.8071 15.2987C14.3732 14.8709 14.1089 14.1881 14.1089 13.1514V2.85321ZM16.1768 13.9288C16.4742 14.2279 16.8839 14.3063 17.283 14.3063C17.283 14.3063 17.283 14.3063 17.283 14.3063L26.5747 14.307L27.7713 14.3071L26.9305 13.4557L16.6571 3.05167L15.8013 2.18501V3.40299V12.8141C15.8013 13.2191 15.8801 13.6304 16.1768 13.9288Z" fill="white" stroke="white" />
                  <path d="M14.6464 31.3536C14.8417 31.5488 15.1583 31.5488 15.3536 31.3536L18.5355 28.1716C18.7308 27.9763 18.7308 27.6597 18.5355 27.4645C18.3403 27.2692 18.0237 27.2692 17.8284 27.4645L15 30.2929L12.1716 27.4645C11.9763 27.2692 11.6597 27.2692 11.4645 27.4645C11.2692 27.6597 11.2692 27.9763 11.4645 28.1716L14.6464 31.3536ZM14.5 19L14.5 31L15.5 31L15.5 19L14.5 19Z" fill="white" />
                </svg>
              </div>
              <div className="welcome-page__file-info">
                <div className="welcome-page__file-title welcome-page__file-title--small">Перечень поддержанных проектов</div>
                <div className="welcome-page__file-subtitle welcome-page__file-subtitle--small">по итогам конкурсного отбора 2024 года</div>
              </div>
            </a>
          </div>

        </div>

        <img className="welcome-page__logo" src={logo} alt="" />

        <div
          className="auth-form login-form"
        >
          <div className="auth-form_scroll">
            <div className="auth-form__title">
              <h3>Добро пожаловать</h3>
            </div>
            <form className="form-common login-form__form">
              <div className="form-common__input">
                <h4>Логин</h4>
                <input
                  id="login-login"
                  className={`form-input ${
                    errorFields.includes('login') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
              <div className="form-common__input">
                <h4>Пароль</h4>
                <div className="form-input__pass-wrapper">
                  <input
                    id="login-pass"
                    className={`form-input form-input__pass ${
                      errorFields.includes('pass') ? 'error' : ''
                    }`}
                    disabled={loading}
                    type={isShowPassword ? 'text' : 'password'}
                  />
                  <div
                    className="pass-watch"
                    onClick={() => setIsShowPassword(!isShowPassword)}
                    onKeyDown={() => {}}
                  />
                </div>
              </div>
              <button
                type="button"
                className="w-btn w-btn__white"
                disabled={loading}
                onClick={onLogin}
              >
                Войти
              </button>
            </form>
          </div>
        </div>

      </div>


      {/* <div
        className="auth-form registration-form"
        style={{ display: isShowRegModal ? '' : 'none' }}
      >
        <span
          className="window-close icon-closet"
          onClick={() => {
            setIsShowRegModal(false);
          }}
          onKeyDown={() => {}}
        />
        <div className="auth-form_scroll">
          <div className="auth-form__title">
            <h3>Регистрация</h3>
            <p>
              Программа‌ ‌финансовой‌ ‌поддержки‌ ‌проведения‌ ‌научных,‌
              ‌клинических‌ ‌и‌ экспериментальных‌ ‌работ‌ ‌по‌
              ‌усовершенствованию‌ ‌методов‌ ‌диагностики‌ ‌и‌ лечения,‌
              ‌направленных‌ ‌на‌ ‌создание‌ ‌высокотехнологичных‌ ‌продуктов
            </p>
          </div>
          <form className="form-common login-form__form">
            <div className="form-common__input">
              <div className="form-common__input_half">
                <h4>
                  Фамилия
                  <span>*</span>
                </h4>
                <input
                  id="reg-lastName"
                  className={`form-input ${
                    errorFields.includes('lastName') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
              <div className="form-common__input_half">
                <h4>
                  Должность
                  <span>*</span>
                </h4>
                <input
                  id="reg-position"
                  className={`form-input ${
                    errorFields.includes('position') ? 'error' : ''
                  }`}
                />
              </div>
            </div>
            <div className="form-common__input">
              <div className="form-common__input_half">
                <h4>
                  Имя
                  <span>*</span>
                </h4>
                <input
                  id="reg-firstName"
                  className={`form-input ${
                    errorFields.includes('firstName') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
              <div className="form-common__input_half">
                <h4>
                  Телефон
                  <span>*</span>
                </h4>
                <input
                  id="reg-phone"
                  className={`form-input ${
                    errorFields.includes('phone') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
            </div>
            <div className="form-common__input">
              <div className="form-common__input_half">
                <h4>
                  Отчество
                  <span>*</span>
                </h4>
                <input
                  id="reg-middleName"
                  className={`form-input ${
                    errorFields.includes('middleName') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
              <div className="form-common__input_half">
                <h4>
                  Email
                  <span>*</span>
                </h4>
                <input
                  id="reg-email"
                  className={`form-input ${
                    errorFields.includes('email') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
            </div>
            <div className="form-common__input">
              <div className="form-common__input_half">
                <h4>
                  Название организации
                  <span>*</span>
                  <small style={{ display: 'block', fontSize: 12 }}>в соответствии с ЕГРЮЛ</small>
                </h4>
                <input
                  id="reg-fullName"
                  className={`form-input ${
                    errorFields.includes('fullName') ? 'error' : ''
                  }`}
                  disabled={loading}
                />
              </div>
              <div className="form-common__input_half form-common__input_check">
                <input
                  type="checkbox"
                  className="form-common__check custom-checkbox"
                  name="circle-check"
                  id="reg-isDzm"
                  disabled={loading}
                />
                <label htmlFor="reg-isDzm">
                  Организация подведомственна Департаменту здваоохранения г.
                  Москвы
                </label>
              </div>
            </div>
            <div className="auth-form__btns">
              <button
                type="button"
                className="w-btn w-btn__green"
                onClick={onRegister}
                disabled={loading}
              >
                Зарегистрировать
              </button>
              <div className="auth-form__param">
                <span>*</span>
                — обязательные поля для заполнения
              </div>
            </div>
          </form>
        </div>
      </div> */}
      {isShowSuccess && (
        <div className="success">
          <h3>Ваша заявка принята на рассмотрение</h3>
          <p>
            Благодарим Вас за регистрацию на портале грантовой программы Мэра
            Москвы по поддержке научно-практических проектов в сфере
            здравоохранения. Ваша заявка на регистрацию будет рассмотрена в
            ближайшее время, уведомление о результате будет отправлено на
            указанный Вами адрес электронной почты
          </p>
          <p>
            <b>Примечание: </b>
            Пожалуйста, обратите внимание, что в некоторых случаях
            письмо с уведомлением может автоматически попасть в папку «Спам»
            Вашего электронного почтового ящика. Если Вы не получите сообщение,
            пожалуйста, проверьте папку «Спам» и при необходимости добавьте
            официальный адрес электронной почты грантовой программы
            medtechapplications@yandex.ru в список надежных отправителей.
          </p>

          <button
            type="button"
            className="w-btn w-btn__green"
            onClick={() => setIsShowSuccess(false)}
            onKeyDown={() => {}}
          >
            Хорошо, спасибо за информацию!
          </button>
        </div>
      )}
      <div
        className="shadow-block"
        style={{
          display:
            isShowLoginModal || isShowRegModal || isShowSuccess ? '' : 'none',
        }}
        onClick={() => {
          setIsShowLoginModal(false);
          setIsShowRegModal(false);
        }}
        onKeyDown={() => {}}
      />
    </div>
  );
}

LoginPage.propTypes = {
  location: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
  // intl: PropTypes.shape().isRequired,
};

export default withRouter(LoginPage);
